import { pushAppToast } from '~/utils/appToastStore'

function normalizeMessage(message) {
  if (typeof message === 'string') return message
  if (message && typeof message.message === 'string') return message.message
  return String(message ?? '')
}

/** Drop-in helpers replacing Element Plus ElMessage. */
export const AppMessage = {
  success(message) {
    pushAppToast({ type: 'success', message: normalizeMessage(message), variant: 'message' })
  },
  warning(message) {
    pushAppToast({ type: 'warning', message: normalizeMessage(message), variant: 'message' })
  },
  error(message) {
    pushAppToast({ type: 'error', message: normalizeMessage(message), variant: 'message' })
  },
  info(message) {
    pushAppToast({ type: 'info', message: normalizeMessage(message), variant: 'message' })
  },
}
